module.exports = __webpack_public_path__ + "img/p1.42f9a63e.jpg";